export default "__VITE_ASSET__dwjMGxNZ__"